import React from 'react';
import 'twin.macro';
import { BoltIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import ButtonLink from 'components/Buttons/Link';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  description: string;
  description2?: string;
  buttonTitle?: string;
  className?: string;
}

export function Paywall(props: Props) {
  const { t } = useTranslation(['common']);
  const {
    title,
    description,
    description2,
    buttonTitle = t('common:paywall.button'),
    className,
  } = props;
  return (
    <div className={className}>
      <div tw="flex items-center mb-5 gap-x-4">
        <div tw="shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-brand-moderate bg-opacity-40">
          <LockClosedIcon tw="h-6 w-6 text-brand-intense" aria-hidden="true" />
        </div>
        <div tw="text-left">
          <div tw="text-lg leading-6 font-medium text-neutral-intense">
            {title}
          </div>
        </div>
      </div>
      <div tw="space-y-8">
        <div tw="text-neutral-intense ">{description}</div>
        {description2 && <div tw="text-neutral-quiet">{description2}</div>}
        <ButtonLink to="/pricing" intent="primary" icon={BoltIcon} large>
          {buttonTitle}
        </ButtonLink>
      </div>
    </div>
  );
}
